import { useContext } from 'react'
import { ActionIcon, Tooltip } from '@mantine/core'
import { IconMicrophone } from '@tabler/icons-react'
import { AiDictateContext } from './AiDictateContext'
import type { DictationField } from './dictationFields'

/** Per-field mic shortcut — targets its field explicitly, no focus needed. */
export function DictateFieldMic({ field, testId }: { field: DictationField; testId: string }) {
  const dictate = useContext(AiDictateContext)
  // `enabled` also covers the live-scribe-session mic contention and the
  // no-linked-encounter dead end — same gate as the toolbar button.
  if (!dictate?.supported || !dictate.enabled) return null

  return (
    <Tooltip label={`Dictate into ${field.label}`} withArrow>
      <ActionIcon
        variant="subtle"
        color="blue"
        size="sm"
        disabled={dictate.phase !== 'idle'}
        onClick={() => {
          const element = document.querySelector(`[data-testid="${testId}"]`)
          if (element) dictate.start({ field, element })
        }}
        aria-label={`Dictate into ${field.label}`}
        data-testid={`dictate-mic-${testId}`}
      >
        <IconMicrophone size={15} />
      </ActionIcon>
    </Tooltip>
  )
}
